"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _useWeekdays = _interopRequireDefault(require("@oberoninternal/travelbase-ds/hooks/useWeekdays"));
var _react = _interopRequireDefault(require("react"));
var _OperatingHoursRow = _interopRequireDefault(require("./OperatingHoursRow"));
var _Stack = _interopRequireDefault(require("./Stack"));
const _excluded = ["operatingHours"];
var __jsx = _react.default.createElement;
const weekdays = ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'];
const OperatingHours = _ref => {
  let {
      operatingHours
    } = _ref,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  const weekDates = (0, _useWeekdays.default)({
    weekStartsOn: 1
  });
  return __jsx(_Stack.default, (0, _extends2.default)({
    spacing: 3
  }, rest), weekdays.map((weekday, weekdayIndex) => {
    const times = operatingHours?.[weekday];
    if (!times) {
      return null;
    }
    return __jsx(_OperatingHoursRow.default, {
      key: weekday,
      times: times,
      weekdate: weekDates[weekdayIndex]
    });
  }));
};
var _default = exports.default = OperatingHours;